<v-public-bottom-gradient-wrapper>
  <div
    class="flex flex-col gap-10 w-[90vw] md:min-w-sm md:w-xl relative max-w-[480px]">
    <v-public-logo-header
      [header]="'pages.verification.header' | transloco"
      [subheader]="
        'pages.verification.subheader' | transloco
      "></v-public-logo-header>
    <v-card variant="glass-v2" padding="lg">
      <div slot="body" class="mt-4">
        @if (verificationFlow(); as flow) {
          <app-kratos-form-v2
            #kf
            [renderFallback]="false"
            [flow]="flow"
            (submitFlow)="submitFlow($event)">
            <div class="grid col-span-1 gap-4">
              @if (kf.hasMessages()) {
                <ng-template vKfName="messages"></ng-template>
              }

              @if (kf.isVisible('code-input-email')) {
                <div class="col-span-1">
                  <ng-template [vKfName]="'code-input-email'"> </ng-template>
                </div>
              }

              @if (kf.isVisible('code-input-code')) {
                <div class="col-span-1">
                  <ng-template [vKfName]="'code-input-code'"> </ng-template>
                </div>
              }

              @if (kf.isVisible('code-input-method-code')) {
                <div class="col-span-1">
                  <ng-template [vKfName]="'code-input-method-code'">
                  </ng-template>
                </div>
              }
            </div>
          </app-kratos-form-v2>
        }
      </div>
    </v-card>
  </div>
</v-public-bottom-gradient-wrapper>
